import React from 'react';
import { breakpoints, color } from '../../styles/theme';
import Row from '../grid/Row';
import Col from '../grid/Col';
import { t } from '../../utils/i18n';
import DisplayOn from '../common/DisplayOn';
import FlexDiv from '../common/FlexDiv';
import Spacing from '../common/Spacing';
import { IconName } from '../common/Icon';
import DestinationFactBox from './DestinationFactBox';

interface DestinationFactBoxListProps {
  population?: string;
  currency?: string;
  timeDifference?: string;
}

const DestinationFactBoxList: React.FunctionComponent<DestinationFactBoxListProps> =
  ({ population, currency, timeDifference }) => {
    const factData = [
      {
        label: t('Väkimäärä'),
        icon: 'travel-population',
        content: population,
        testId: 'population-column'
      },
      {
        label: t('Valuutta'),
        icon: 'travel-currency',
        content: currency,
        testId: 'currency-column'
      },
      {
        label: t('Aikaero'),
        icon: 'travel-timezone',
        content: timeDifference,
        testId: 'time-difference-column'
      }
    ];

    return (
      <div className="destination-fact-box-list">
        <DisplayOn small medium>
          <Row>
            {factData.map((fact) => {
              if (!fact.content) {
                return null;
              }
              return (
                <Col
                  size={12}
                  data-testid={fact.testId}
                  className="fact-col"
                  key={fact.label}
                >
                  <DestinationFactBox
                    label={fact.label}
                    icon={fact.icon as IconName}
                    content={fact.content}
                  />
                </Col>
              );
            })}
          </Row>
        </DisplayOn>
        <DisplayOn large>
          <FlexDiv>
            {factData.map((fact) => {
              if (!fact.content) {
                return null;
              }
              return (
                <Spacing right={5} key={fact.label}>
                  <DestinationFactBox
                    label={fact.label}
                    icon={fact.icon as IconName}
                    content={fact.content}
                  />
                </Spacing>
              );
            })}
          </FlexDiv>
        </DisplayOn>
        {/*language=CSS*/}
        <style jsx>{`
          @media ${breakpoints.large} {
            .destination-fact-box-list {
              border-top: solid 1px ${color.light};
            }
          }
        `}</style>
      </div>
    );
  };

export default DestinationFactBoxList;
